// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2362 ? "ec5d7cc0" : chunkId) + "." + {"2362":"3472cf2baad37e50","2938":"b1c3003fd7453d8a","3375":"221f5c6318c18b18"}[chunkId] + ".js";
};